import { socketClient } from "./socketClient";
import { SocketEvents } from "./events";

// ==========================================
// User Status
// ==========================================

export const emitUserOnline = (userId: string) => {
  socketClient.emit(SocketEvents.USER_ONLINE, userId);
};

export const emitUserOffline = (userId: string) => {
  socketClient.emit(SocketEvents.USER_OFFLINE, userId);
};

// ==========================================
// Call Initiation
// ==========================================

export const emitCallInitiate = (
  recipientId: string,
  callType: "audio" | "video"
) => {
  const payload: SocketTypes.CallInitiatePayload = {
    recipient_id: recipientId,
    call_type: callType,
  };
  console.log("[Socket] Emitting call:initiate:", payload);
  socketClient.emit(SocketEvents.CALL_INITIATE, payload);
};

// ==========================================
// Call Acceptance
// ==========================================

export const emitCallAccept = (requestId: string) => {
  const payload: SocketTypes.CallAcceptPayload = { request_id: requestId };
  console.log("[Socket] Emitting call:accept:", requestId);
  socketClient.emit(SocketEvents.CALL_ACCEPT, payload);
};

// ==========================================
// Call Rejection
// ==========================================

export const emitCallReject = (
  requestId: string,
  reason?: "busy" | "declined" | "unavailable"
) => {
  const payload: SocketTypes.CallRejectPayload = {
    request_id: requestId,
    reason,
  };
  console.log("[Socket] Emitting call:reject:", requestId, reason);
  socketClient.emit(SocketEvents.CALL_REJECT, payload);
};

// ==========================================
// Call Cancellation
// ==========================================

export const emitCallCancel = (requestId: string) => {
  const payload: SocketTypes.CallCancelPayload = { request_id: requestId };
  console.log("[Socket] Emitting call:cancel:", requestId);
  socketClient.emit(SocketEvents.CALL_CANCEL, payload);
};

// ==========================================
// Call Connection
// ==========================================

export const emitCallConnected = (callId: string, participantId: string) => {
  const payload: SocketTypes.CallConnectedPayload = {
    call_id: callId,
    participant_id: participantId,
  };
  console.log("[Socket] Emitting call:connected:", payload);
  socketClient.emit(SocketEvents.CALL_CONNECTED, payload);
};

// ==========================================
// Call Termination
// ==========================================

export const emitCallEnd = (callId: string) => {
  const payload: SocketTypes.CallEndPayload = { call_id: callId };
  console.log("[Socket] Emitting call:end:", callId);
  socketClient.emit(SocketEvents.CALL_END, payload);
};

// ==========================================
// Call Recovery
// ==========================================

export const emitCallRejoin = (callId: string) => {
  const payload: SocketTypes.CallRejoinPayload = { callId };
  console.log("[Socket] Emitting call:rejoin:", callId);
  socketClient.emit(SocketEvents.CALL_REJOIN, payload);
};

// ==========================================
// Admin Monitoring (ADMIN role only)
// Note: Role validation happens in useAdminMonitoring hook
// ==========================================

export const emitAdminJoinCall = (
  callId: string,
  monitoringReason: SocketTypes.AdminMonitoringReason
) => {
  const payload: SocketTypes.AdminJoinCallPayload = {
    call_id: callId,
    monitoring_reason: monitoringReason,
  };
  console.log("[Socket] Emitting admin:join:call:", payload);
  socketClient.emit(SocketEvents.ADMIN_JOIN_CALL, payload);
};

export const emitAdminLeaveCall = (callId: string) => {
  const payload = { call_id: callId };
  console.log("[Socket] Emitting admin:leave:call:", payload);
  socketClient.emit(SocketEvents.ADMIN_LEAVE_CALL, payload);
};

// ==========================================
// Room Signaling
// ==========================================

export const emitJoinRoom = (roomId: string) => {
  socketClient.emit(SocketEvents.JOIN_ROOM, roomId);
};

export const emitLeaveRoom = (roomId: string) => {
  socketClient.emit(SocketEvents.LEAVE_ROOM, roomId);
};

